import { buildFilterProductsQuery } from '@vue-storefront/core/helpers'
import { mapGetters } from 'vuex'
import pickBy from 'lodash-es/pickBy'
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import { productsTotal } from 'src/modules/products_categories/queries/products'

export default {
  name: 'CategorySidebar',
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('category', ['getCurrentCategory', 'getActiveCategoryFilters', 'getCurrentCategoryProductQuery']),
    ...mapGetters({
      currentPartnerCode: 'partners/getCurrentPartnerCode'
    }),
    category () {
      return this.getCurrentCategory
    },
    activeFilters () {
      return this.getActiveCategoryFilters
    },
    availableFilters () {
      return pickBy(this.filters, (filter) => { return (filter.length) })
    },
    hasActiveFilters () {
      return Object.keys(this.activeFilters).length !== 0
    },
    stateParentId () {
      return this.category.entity_id;
    }
  },
  watch: {
    stateParentId: function () {
      this.createCategoryNavigation()
    }
  },
  mounted () {
    this.resetAllFilters()
    this.createCategoryNavigation();
  },
  methods: {
    createCategoryNavigation () {
      if (this.categories !== []) {
        this.categories = [];
      }
      this.categories.push(this.category);
      this.parentId = this.category.entity_id;
      let subCategoryGetter = this.$store.dispatch('category/list', {parent: this.parentId});
      subCategoryGetter.then((data) => {
        data.items.forEach((subCategory, index) => {
          productsTotal(subCategory).then(productsQuery => {
            this.$store.dispatch('product/list', {
              query: productsQuery,
              size: 1,
              sort: 'updated_at:desc'
            }).then(products => {
              subCategory.productsTotal = products.total;
              this.categories.push(subCategory);
            })
          })
        });
      })
    },
    categoryLink (category) {
      if (this.currentPartnerCode !== undefined) {
        return '/store/' + this.currentPartnerCode + formatCategoryLink(category)
      }
    },
    sortById (filters) {
      return [...filters].sort((a, b) => { return a.id - b.id })
    },
    resetAllFilters () {
      if (this.hasActiveFilters) {
        this.$bus.$emit('filter-reset')
        this.$store.dispatch('category/resetFilters')
        this.$store.dispatch('category/searchProductQuery', {})
        this.$store.dispatch('category/mergeSearchOptions', {
          searchProductQuery: buildFilterProductsQuery(this.category, this.activeFilters)
        })
        this.$store.dispatch('category/products', this.getCurrentCategoryProductQuery)
      }
    }
  }
}
